<!--
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-03 19:07:08
 * @Description: 这是提示信息专用页 
-->
<template>
    <div class="page-outter">
        <Empty :content="' '" >
            <img class="pic"
                :src="oPageDate.pic"
            />
            <div class="title">
                {{ oPageDate.i18nKey }}
            </div>
        </Empty>
        <!-- ↓ 用于调试的按钮 -->
        
    </div>
</template>

<script setup lang="ts">
import loginFailed from '@/assets/imgs/login-failed.webp';
import loginExpired from '@/assets/imgs/login-expired.webp';
import noNetwork from '@/assets/imgs/no-network.webp';
import siteLogo from '@/assets/BetCorgiLogo/Site-logo-898x243.png'; 
// ----- ↑ 图像 --------------------------------------------------------------- 
import {toCloseLoading} from '@/layouts/gameCoat/ts/gameCoat';
import { useLoadingStore } from '@/stores/loading';
import useGlobalStore from '@/stores/global';

const globalStore = useGlobalStore();
const loadingStore = useLoadingStore();
const {t: $tFn} = useNuxtApp().$i18n;
const oRoute = useRoute();

const oCodeMap = {
    'notLoggedIn': { // 没登录
        i18nKey: 'commonInfo.notLoggedIn', 
        pic: loginFailed,
    },
    'logInFailed': { // 登录失败 
        i18nKey: 'commonInfo.logInFailed', 
        pic: loginFailed,
    },
    'userOffLineDesc': { // 登录过期（被踢下线了之类的） 
        i18nKey: 'commonInfo.userOffLineDesc', 
        pic: loginExpired,
    },
    'connectionFailed': { // 首次连接 ws 失败或超时 
        i18nKey: 'commonInfo.connectionFailed', 
        pic: noNetwork,
    },
};

const oPageDate = computed(()=>{
    const sQueryKey = oRoute.query?.['key'] as any;
    const oPageObj = oCodeMap[sQueryKey] || {};
    const { i18nKey, pic } = oPageObj;
    const oResult = {
        pic: pic || siteLogo,
        i18nKey: i18nKey ? $tFn(i18nKey) : '',
    }
    return oResult;
});

onBeforeMount(()=>{
    // ↓ 关闭遮罩 1（都跳到这里了，就关闭遮罩吧） 
    loadingStore.showLoading = false;
    // ↓ 关闭遮罩 2
    toCloseLoading();
});

</script>

<style lang="scss" scoped>
.page-outter{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - var(--header-heigh) - 15vh);
}

.pic{
    display: block;
    width: 165px;
    max-width: 90vw;
    margin: 0 auto 0;
}

.title{
    // font-size: 26px;
    // color: var(--color_grey-40);
    // text-align: center;
    width: 90vw;
    max-width: 500px;
    color: rgba(167, 181, 202, 1);
    padding: 20px 25px 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
}

.test-box{
    text-align: center;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    button{
        display: block;
        margin: 0 6px;
        padding: 2px 6px;
        color: #aaa;
        background: #3335;
    }
}
</style>

